import React, { useState } from "react";
import styled, { withTheme } from "styled-components";
import Button from "common/Button";
import Modal from "common/Modal";
import { Close, Bookmark } from "@material-ui/icons";
import { saveSection, deleteSaveSection, getSavedSection } from "utils/api";

const BREAKPOINT = "850px";

const Holder = styled.div`
  display: flex;
  font-size: 14px;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: flex-start;
  position: absolute;
  top: 50px;
  height: auto;
  width: 270px;
  z-index: 1;
  background-color: #fff;
  left: 0;
  @media (max-width: ${BREAKPOINT}) {
    width: auto;
  }
`;

// @todo: how to handle error?
async function setSavedSection(query, setToggleModal, reloadSavedLocation) {
  await saveSection(query);
  reloadSavedLocation();
  setToggleModal(0);
}

function SavedSection({
  setToggleModal,
  isSaved,
  reloadSavedLocation,
  query,
  selectedChannels,
  theme,
}) {
  const [openWarningModal, setOpenWarningModal] = useState(false);
  return (
    <Holder>
      {isSaved ? (
        <Button
          iconColor={theme.black100}
          typeOfIcon="small"
          margin="0 15px 0 0"
          color={theme.interactionColor}
          width="100%"
          align="left"
          background={theme.whiteBackground}
          Icon={Close}
          hoverBackground={theme.hoverColorGray}
          text="Standardregion entfernen"
          onClick={() => {
            deleteSaveSection();
            setToggleModal(0);
            reloadSavedLocation();
          }}
        />
      ) : (
        <Button
          margin="0 15px 0 0"
          width="100%"
          iconColor={theme.black100}
          typeOfIcon="small"
          color={theme.interactionColor}
          align="left"
          Icon={Bookmark}
          background={theme.whiteBackground}
          title="Diese Region als Standard festlegen"
          alt="Diese Region als Standard festlegen"
          hoverBackground={theme.hoverColorGray}
          text="Diese Region als Standard festlegen"
          onClick={() =>
            selectedChannels.length > 0
              ? setSavedSection(query, setToggleModal, reloadSavedLocation)
              : setOpenWarningModal(true)
          }
        />
      )}
      {openWarningModal && (
        <Modal
          isOpen={openWarningModal}
          modalTitle="Error"
          noBottomMargin
          smallModal
          onRequestClose={() => setOpenWarningModal(false)}
        >
          <div style={{ padding: "18px" }}>
            Please choose a channel to be able to define a standard section
          </div>
        </Modal>
      )}
    </Holder>
  );
}

export default withTheme(SavedSection);
